import React, { FC } from 'react'

import { IconShowPasswordProps } from './IconShowPassword.types'
import * as Styled from './styles/IconShowPassword.style'

import { nonThemeableRules } from '../../ruleSet'

const IconShowPassword: FC<IconShowPasswordProps> = ({
  size = nonThemeableRules.defaultSize as number as IconShowPasswordProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconShowPasswordProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <g fill='#333'>
          <path d='M79.962 24c22.21 0 42.92 8.8 59.628 25.4l.838.847c13.11 13.404 18.774 26.355 18.872 26.453.1.1.1.1.1.2.8 2.1.8 4.5 0 6.6-.1.2-.1.3-.2.5l-.294.595C155.097 92.155 130.426 136 79.962 136c-22.21 0-42.92-8.8-59.627-25.4l-.838-.847C6.387 96.349.723 83.398.625 83.3l-.078-.085c-.022-.031-.022-.055-.022-.115-.7-2.1-.7-4.5 0-6.6.1-.2.1-.3.2-.5l.294-.595C4.828 67.845 29.499 24 79.962 24Zm0 8C33.441 32 10.93 73.4 8.03 79.3c-.1.4-.1.7 0 1.1l.323.656C11.407 87.116 33.676 128 79.962 128c46.522 0 69.033-41.4 71.934-47.3.1-.3.1-.7 0-1.1l-.323-.656C148.518 72.884 126.249 32 79.963 32Z' />
          <path d='M80 48c17.599 0 32 14.4 32 32 .097 17.424-13.819 31.614-31.174 31.993L80.3 112H80c-17.6 0-32-14.4-32-32s14.4-32 32-32Z' />
        </g>
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconShowPassword
